import { CancelBookingPage } from '@/app/pages/booking/cancellation/cancel-booking';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/booking/cancellation/$orderNumber')({
  component: CancelBookingPage,
});
